module.exports = __webpack_public_path__ + "static/netflix-logo-4cbe4c21e2bb490dbd8445ab99e8cfec.png";